import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('node-view-wrapper', {
    staticClass: "d-inline-block mb-2",
    staticStyle: {
      "max-width": "100%"
    }
  }, [_c('vue-draggable-resizable', {
    staticClass: "position-static",
    staticStyle: {
      "max-width": "100%"
    },
    style: {
      borderColor: _vm.$vuetify.theme.dark ? 'white' : 'black'
    },
    attrs: {
      "draggable": false,
      "handles": ['mr'],
      "lock-aspect-ratio": _vm.lockAspectRatio,
      "w": _vm.width,
      "h": _vm.height
    },
    on: {
      "activated": _vm.onActivated,
      "resizestop": _vm.onResize
    }
  }, [_c('div', {
    staticClass: "tw-w-full tw-h-full"
  }, [_c('img', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isImageLoading,
      expression: "!isImageLoading"
    }],
    ref: "resizableImg",
    staticStyle: {
      "max-height": "100%",
      "max-width": "100%"
    },
    style: {
      width: _vm.width,
      height: _vm.height
    }
  }, 'img', _vm.imgAttrs, false)), _vm.isImageLoading ? _c('div', {
    staticClass: "tw-flex tw-bg-gray-200 tw-justify-center tw-items-center tw-h-full tw-w-full tw-relative"
  }, [_c('img', {
    staticStyle: {
      "filter": "blur(4px)",
      "max-height": "100%",
      "max-width": "100%",
      "width": "200px",
      "height": "200px"
    },
    attrs: {
      "src": _vm.onLoadImage
    }
  }), _c(VProgressCircular, {
    staticClass: "position-absolute",
    attrs: {
      "color": "primary",
      "indeterminate": ""
    }
  })], 1) : _vm._e()])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };